// Opt-in codec for the Offices/Leases faceted lists. Legacy consumers retain
// empty-means-all; version 2 records an intentional empty selection.
export const CHECKED_FILTER_VERSION = 2;

export function allOptionValues(dimension) {
  return dimension.options.map(({ value }) => value);
}

export function normalizeCheckedSelections(dimensions, selections = {}, baseline = {}, {
  legacy = false, emptyMeansNone = [], preserveMissing = [],
} = {}) {
  const next = { ...selections };
  for (const dim of dimensions) {
    const selected = selections[dim.id];
    if (selected === undefined && preserveMissing.includes(dim.id)) continue;
    next[dim.id] = selected === undefined
      ? [...(baseline[dim.id] ?? allOptionValues(dim))]
      : legacy && !selected.length && !emptyMeansNone.includes(dim.id)
        ? allOptionValues(dim)
        : [...selected];
  }
  return next;
}

// Adapt checked selections to existing predicates, bypassing fully checked
// groups so null/unclassified records remain eligible. None is handled first.
export function checkedPredicateSelections(dimensions, selections, legacyEmpty = false) {
  if (!legacyEmpty && dimensions.some(({ id, options }) => options.length > 0 && selections[id]?.length === 0)) return null;
  const next = { ...selections };
  for (const dim of dimensions) {
    if (dim.options.every(({ value }) => selections[dim.id]?.includes(value))) delete next[dim.id];
  }
  return next;
}
